<section class="space-y-4 p-1">
  <form [formGroup]="cashSessionForm" class="space-y-4">
    @if (shouldShowCashRegisterSelect()) {
      <app-input-select
        [label]="'Caja'"
        id="cash-session-cash-register"
        [controlName]="cashSessionForm.controls.cash_register_id"
        [options]="cashRegisterOptions()"
        [loading]="isLoadingCashRegisters()"
        [placeholder]="'Selecciona una caja'"
      ></app-input-select>
    }

    @if (cashRegisterLoadError()) {
      <section
        class="rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900 dark:border-amber-800 dark:bg-amber-900/20 dark:text-amber-100"
      >
        {{ cashRegisterLoadError() }}
      </section>
    }

    @if (noAvailableCashRegistersMessage()) {
      <section
        class="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-4 text-sm text-slate-700 dark:border-slate-700 dark:bg-slate-900/60 dark:text-slate-200"
      >
        <div class="flex gap-3">
          <span
            class="mt-0.5 inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-amber-100 text-amber-700 dark:bg-amber-400/15 dark:text-amber-200"
            aria-hidden="true"
          >
            <i class="fa-solid fa-cash-register text-sm"></i>
          </span>

          <div class="min-w-0 space-y-1">
            <p class="text-base font-semibold text-slate-900 dark:text-white">
              Caja ocupada
            </p>
            <p class="leading-6">
              {{ noAvailableCashRegistersMessage() }}
            </p>
          </div>
        </div>
      </section>
    } @else if (occupiedCashRegisterSummary()) {
      <section
        class="rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900 dark:border-amber-800 dark:bg-amber-900/20 dark:text-amber-100"
      >
        {{ occupiedCashRegisterSummary() }}
      </section>
    }

    @if (openingContextError()) {
      <section
        class="rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900 dark:border-amber-800 dark:bg-amber-900/20 dark:text-amber-100"
      >
        {{ openingContextError() }}
      </section>
    }

    @if (resolvedCashRegister()) {
    <div class="space-y-3 pt-1">
      <div>
        <p class="text-base font-semibold text-slate-900 dark:text-white">
         ¿Con cuánto efectivo vas a iniciar el turno?
        </p>
      </div>

      <div>
        <label
          for="cash-session-opening-amount"
          class="sr-only"
        >
          Efectivo inicial
        </label>

        <div class="relative">
          <span
            class="pointer-events-none absolute inset-y-0 left-3 flex items-center text-sm text-slate-400"
          >
            $
          </span>
          <input
            id="cash-session-opening-amount"
            type="number"
            min="0"
            [max]="openingAmountMax"
            step="0.01"
            formControlName="opening_amount"
            class="h-12 w-full rounded-2xl border border-slate-300 bg-white pl-8 pr-4 text-lg font-semibold text-slate-900 outline-none transition focus:border-primary-500 focus:ring-2 focus:ring-primary-100 dark:border-slate-600 dark:bg-slate-950 dark:text-white dark:focus:ring-primary-900/40"
            [class.border-rose-400]="openingAmountErrorMessage"
            placeholder="0.00"
          />
        </div>

        <div class="mt-2 min-h-4 text-xs leading-tight text-rose-600 dark:text-rose-300">
          @if (openingAmountErrorMessage) {
            <p>
              {{ openingAmountErrorMessage }}
            </p>
          }
        </div>
      </div>
    </div>

    <app-input-textarea
      [label]="'Notas'"
      id="cash-session-opening-notes"
      [controlName]="cashSessionForm.controls.notes"
      [rows]="3"
      [maxLength]="300"
      [placeholder]="'Escribe una nota si la necesitas.'"
    ></app-input-textarea>
    }
  </form>

  @if (noAvailableCashRegistersMessage()) {
    <div class="grid gap-2 pt-1 sm:grid-cols-2">
      <app-button
        [label]="cancelLabel()"
        [variant]="'secondary'"
        [disabled]="isBusy()"
        [fullWidth]="true"
        (clicked)="close()"
      ></app-button>

      @if (canCloseOccupiedCashSession()) {
        <app-button
          [label]="'Cerrar caja ocupada'"
          [icon]="'fa-solid fa-lock-open'"
          [showLabelOnMobile]="true"
          [disabled]="isBusy()"
          [fullWidth]="true"
          (clicked)="openCloseOccupiedCashSessionModal()"
        ></app-button>
      }
    </div>
  } @else {
    <div class="grid grid-cols-2 gap-2 pt-1">
      <app-button
        [label]="cancelLabel()"
        [variant]="'danger'"
        [disabled]="isBusy()"
        [fullWidth]="true"
        (clicked)="close()"
      ></app-button>

      <app-button
        [label]="submitLabel()"
        [loadingLabel]="'Abriendo caja...'"
        [isLoading]="isSubmitting()"
        [disabled]="isBusy() || !resolvedCashRegister()"
        [fullWidth]="true"
        (clicked)="submit()"
      ></app-button>
    </div>
  }
</section>
